import { useQuery } from "react-query";
import servicesUtils from "../../../utils/servicesUtils";
import { transformPatientReminders } from "../transformers";
var useGetPatientReminders = function useGetPatientReminders(patientUid) {
  return useQuery(["patient-reminders", patientUid], function () {
    return servicesUtils.getService("/patients/".concat(patientUid, "/reminder/list/")).then(function (data) {
      return transformPatientReminders(data);
    });
  }, {
    enabled: !!patientUid
  });
};
export default useGetPatientReminders;